import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { TranslationListComponent } from './translation-list/translation-list.component';
import { TranslationOverridesService } from './translation-overrides.service';

@NgModule({
  declarations: [TranslationListComponent],
  imports: [SharedModule],
  providers: [TranslationOverridesService],
})
export class TranslationModule {}
